<template>
  <div class="floating-icon floating-icon-hidden" id="div_close">
    <button
      type="button"
      class="sidebar-toggle sidebar-toggle--close"
      aria-label="Ocultar menú lateral"
      title="Ocultar menú"
      @click.stop="hidden"
    >
      <svg
        class="sidebar-toggle__icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M15 6L9 12L15 18"
          stroke="currentColor"
          stroke-width="2.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    hidden() {
      const sidebar = document.getElementById('body__sidebar')
      if (sidebar) {
        sidebar.classList.add('open')
      }

      const divClose = document.getElementById('div_close')
      if (divClose) divClose.style.display = 'none'

      const divOpen = document.getElementById('div_open')
      if (divOpen) divOpen.style.display = 'flex'
    },
  },
}
</script>
